import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function TermsOfService() {
  return (
    <Container className="py-5">
      <Row>
        <Col>
          <h1 className="mb-4">Conditions Générales d'Utilisation</h1>
          <p className="lead">Dernière mise à jour : 11 mai 2025</p>

          <section className="mb-5">
            <h2>1. Introduction</h2>
            <p>
              Bienvenue sur BoxPlaisir.be, un site web opéré par All Diffusion
              SNC, société enregistrée en Belgique sous le numéro d'entreprise
              1016199219, TVA BE1016199219, dont le siège social est situé au
              rue du Château 13, 5190 Jemeppe-sur-Sambre.
            </p>
            <p>
              En accédant et en utilisant ce site, vous acceptez de vous
              conformer et d'être lié par les présentes conditions générales
              d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne
              pas utiliser notre site.
            </p>
          </section>

          <section className="mb-5">
            <h2>2. Définitions</h2>
            <ul>
              <li>
                <strong>"Nous", "notre", "nos"</strong> font référence à All
                Diffusion SNC, exploitant du site BoxPlaisir.be.
              </li>
              <li>
                <strong>"Vous", "votre", "vos"</strong> font référence à
                l'utilisateur ou au client du site.
              </li>
              <li>
                <strong>"Site"</strong> désigne le site web BoxPlaisir.be.
              </li>
              <li>
                <strong>"Service"</strong> désigne tous les services proposés
                par BoxPlaisir, y compris la vente de box thématiques.
              </li>
              <li>
                <strong>"Contenu"</strong> désigne toutes les informations et
                données disponibles sur le site.
              </li>
            </ul>
          </section>

          <section className="mb-5">
            <h2>3. Inscription et Compte</h2>
            <p>
              Pour certaines fonctionnalités de notre site, il peut vous être
              demandé de créer un compte. Vous pouvez vous inscrire directement
              ou utiliser l'authentification Google.
            </p>
            <p>
              Vous êtes responsable de maintenir la confidentialité de vos
              informations de connexion et de toutes les activités qui se
              produisent sous votre compte.
            </p>
            <p>
              Vous êtes tenu de nous informer immédiatement de toute utilisation
              non autorisée de votre compte ou de toute autre violation de
              sécurité.
            </p>
          </section>

          <section className="mb-5">
            <h2>4. Authentification via Google</h2>
            <p>
              Nous proposons l'authentification via Google comme méthode de
              connexion alternative. En utilisant cette option :
            </p>
            <ul>
              <li>
                Vous autorisez BoxPlaisir à accéder à votre nom, email et photo
                de profil Google
              </li>
              <li>
                Vous acceptez les conditions d'utilisation et la politique de
                confidentialité de Google
              </li>
              <li>
                Vous acceptez que nous puissions stocker et utiliser les
                informations obtenues via Google conformément à notre politique
                de confidentialité
              </li>
            </ul>
          </section>

          <section className="mb-5">
            <h2>5. Commandes et Paiements</h2>
            <p>
              En passant une commande sur notre site, vous garantissez que :
            </p>
            <ul>
              <li>Vous êtes légalement capable de conclure des contrats</li>
              <li>
                Les informations que vous fournissez sont exactes et complètes
              </li>
              <li>
                Vous acceptez de payer intégralement tous les produits que vous
                achetez
              </li>
            </ul>
            <p>
              Nous nous réservons le droit de refuser ou d'annuler une commande
              pour quelque raison que ce soit.
            </p>
          </section>

          <section className="mb-5">
            <h2>6. Livraison</h2>
            <p>
              Nous nous efforçons de livrer les produits dans les délais
              indiqués. Cependant, ces délais sont donnés à titre indicatif et
              nous ne pouvons être tenus responsables des retards indépendants
              de notre volonté.
            </p>
          </section>

          <section className="mb-5">
            <h2>7. Droit de rétractation</h2>
            <p>
              Conformément à la législation belge et européenne, vous disposez
              d'un délai de 14 jours à compter de la réception du produit pour
              exercer votre droit de rétractation, sans avoir à justifier de
              motifs ni à payer de pénalités.
            </p>
            <p>
              Pour exercer ce droit, veuillez nous contacter à l'adresse email
              suivante :{" "}
              <a href="mailto:contact@boxplaisir.be">contact@boxplaisir.be</a>.
            </p>
          </section>

          <section className="mb-5">
            <h2>8. Propriété intellectuelle</h2>
            <p>
              Tout le contenu présent sur notre site, y compris les textes,
              graphiques, logos, images, et logiciels, est la propriété de
              BoxPlaisir ou de ses fournisseurs de contenu et est protégé par
              les lois belges et internationales sur la propriété
              intellectuelle.
            </p>
          </section>

          <section className="mb-5">
            <h2>9. Limitation de responsabilité</h2>
            <p>
              Notre site et ses contenus sont fournis "tels quels". Nous ne
              garantissons pas que notre site sera exempt d'erreurs ou
              disponible de façon ininterrompue.
            </p>
            <p>
              Dans la mesure permise par la loi, nous excluons toute
              responsabilité pour les dommages indirects, consécutifs ou
              accessoires résultant de l'utilisation de notre site.
            </p>
          </section>

          <section className="mb-5">
            <h2>10. Modifications des conditions</h2>
            <p>
              Nous nous réservons le droit de modifier ces conditions à tout
              moment. La version la plus récente sera toujours disponible sur
              notre site.
            </p>
          </section>

          <section className="mb-5">
            <h2>11. Droit applicable et juridiction compétente</h2>
            <p>
              Les présentes conditions sont régies par le droit belge. Tout
              litige relatif à leur interprétation et/ou à leur exécution relève
              des tribunaux belges.
            </p>
          </section>

          <section className="mb-5">
            <h2>12. Contact</h2>
            <p>
              Pour toute question concernant ces conditions, veuillez nous
              contacter :
            </p>
            <ul>
              <li>
                Par email :{" "}
                <a href="mailto:contact@boxplaisir.be">contact@boxplaisir.be</a>
              </li>
              <li>
                Par courrier : All Diffusion SPRL, rue du Château 13, 5190
                Jemeppe-sur-Sambre, Belgique
              </li>
            </ul>
          </section>
        </Col>
      </Row>
    </Container>
  );
}

export default TermsOfService;
